import { isMobile } from "react-device-detect"
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { AllContext } from "../context/ContextAll";
import { useContext, useEffect, useState } from "react";
import { getAuth, signOut } from "firebase/auth";

//icons
import { IoCloseSharp } from "react-icons/io5";
import { GiHamburgerMenu } from "react-icons/gi";
import { CiInstagram } from "react-icons/ci";
import { FaYoutube, FaWhatsapp } from "react-icons/fa";

export const NAV = () => {
  return(
    <>
      {isMobile ? <NavMobile2025/> : <NavPC/>}
    </>
  )
}


const NavPC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleInicioClick = () => {
    if (location.pathname === '/') {
      // Ya estás en inicio: scrollea arriba
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      // Estás en otra página: navegá y scrollea arriba
      navigate('/');
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 300);
    }
  };

  const handleLecturaClick = () => {
    navigate('/');
    setTimeout(() => {
      const element = document.getElementById('lectura');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 300);
  };

  return (
    <div className="w-100 d-flex justify-content-center align-items-center m_font_primaryss py-2 m_nav">
      <Link className="fs-5" to="/" onClick={handleInicioClick}>Inicio</Link>
      <a className="fs-5 mx-4" href="#serviciosDESK" onClick={handleLecturaClick}>Lecturas</a>
      <Link className="fs-5" to="/blog" onClick={() => {
        setTimeout(() => {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 0);
      }}>Blog</Link>
      <a className="fs-5 mx-4" target="_blank" href="https://docs.google.com/forms/d/19xJdvKKxDQ5DrYFDw4_jCDG8F1cYilyF98mr2LQzzdo/viewform?edit_requested=true">Artículos</a>
      <Link className="fs-5" to="/membresia" >Membresía</Link>
      <Link className="fs-5 ms-4" to="/sobre-mi" >Sobre Mi</Link>
    </div>
  );
};


const NavMobile2025 = () => {
  const añoActual = new Date().getFullYear();
  const [isOpen, setIsOpen] = useState(false);
  const { setAdmLogeado, setUserEmail, admLogeado } = useContext(AllContext);
  const navigate = useNavigate();
  const auth = getAuth();

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate('/membresia');
      console.log("Sesión cerrada exitosamente");
    } catch (error) {
      console.error("Error al cerrar sesión: ", error);
    }
  };

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const goToInicio = () => {
    navigate('/');
    window.scrollTo({ top: 0, behavior: 'auto' });
    setIsOpen(false);
  };

  const goToLectura = () => {
    navigate('/');
    setIsOpen(false);
    setTimeout(() => {
      const element = document.getElementById('lectura');
      if (element) {
        element.scrollIntoView({ behavior: 'auto' });
      }
    }, 300);
  };

  // Hook para resetear el scroll al principio de la página
  useEffect(() => {
    // Siempre que se cambie de ruta, llevar el scroll a la parte superior
    window.scrollTo(0, 0);
  }, [navigate]);  // Se ejecuta cuando el navegador cambia de ruta

  return (
    <div className="m_nav_container_mobile">
      <div className={`m_menu_desplegableMobile flex-column justify-content-around align-items-center p-5 bg-white ${isOpen ? 'd-flex' : 'm_right_mobile_nav'}`}>

        <h2 className="m_font_primary fw-bold fs-1">ASTROGIGIX</h2>
        <div className="d-flex flex-column justify-content-center h-75 w-75">
          <button className="fs-1 border-0 rounded-2" onClick={goToInicio}>
            INICIO
          </button>

          <button className="fs-1 my-3 border-0 rounded-2" onClick={goToLectura}>
            LECTURAS
          </button>

          <button className="fs-1 border-0 rounded-2" onClick={() => {
            navigate('/blog');
            setIsOpen(false);
          }}>
            BLOG
          </button>

          <button className="fs-1 my-3 border-0 rounded-2" onClick={() => {
            setIsOpen(false);
          }}>
            <a target="_blank" href="https://docs.google.com/forms/d/19xJdvKKxDQ5DrYFDw4_jCDG8F1cYilyF98mr2LQzzdo/viewform?edit_requested=true" rel="noopener noreferrer">ARTÍCULOS</a>
          </button>

          <button className="fs-1 border-0 rounded-2" onClick={() => {
            navigate('/membresia');
            setIsOpen(false);
          }}>
            MEMBRESÍA
          </button>
          <button className="fs-1 mt-3 border-0 rounded-2" onClick={() => {
            navigate('/sobre-mi');
            setIsOpen(false);
          }}>
            Sobre Mi
          </button>

          <button onClick={() => navigate('/dashboard')} className={`fs-1 ${admLogeado ? 'mt-3' : 'd-none'}`}>
            Admin
          </button>

          <button className={`fs-1 ${admLogeado ? '' : 'd-none'}`} onClick={handleLogout}>
            Desconectarme
          </button>
        </div>

        <div className="d-flex flex-column align-items-center text-center">
          <div className="d-flex">
            <a className="text-white m_bg_primary p-2 pb-3 rounded-5" rel="noreferrer noopener" href="https://www.instagram.com/astrogigix/" target="_blank">
              <CiInstagram color='black' size={35} />
            </a>
            <a className="text-white m_bg_primary p-2 pb-3 rounded-5 mx-4" rel="noreferrer noopener" href="https://www.youtube.com/@AstroGigix" target="_blank">
              <FaYoutube color='black' size={35} />
            </a>
            <a className="text-white m_bg_primary p-2 pb-3 rounded-5" rel="noreferrer noopener" href="https://www.youtube.com/@SomosPark" target="_blank">
              <FaWhatsapp color="black" size={30} />
            </a>
          </div>
          <p className="text-white">Derechos reservados ©<span>{añoActual}</span></p>
        </div>
      </div>

      <button className={`m_menu_burger m_bg_primary rounded-2 p-1 ${isOpen ? 'bg-black' : 'bg-white'}`} onClick={toggleMenu}>
        {isOpen ? <IoCloseSharp size={30} color="white" /> : <GiHamburgerMenu size={30} color="black" />}
      </button>
    </div>
  );
};
